<template>
  <app-layout>
    <a-drawer
        width="400"

        placement="right"
        :closable="false"
        v-model:visible="visible"
        :after-visible-change="afterVisibleChange"
    >

      <template #title>
        <label class="font-bold text-2xl">Settings</label>
      </template>
      <div class="flex flex-col">
        <div class="font-black text-black text-lg">

          <label>Host: </label>
          <a-select
              v-model:value="moderator"
              ref="select"
              class="block shadow w-full"
              @change="changeModerator($event)"
          >
            <a-select-option v-for="player in players" :value="player.id"
            >{{ player.name }}
            </a-select-option>
            <a-select-option value="no">No Host</a-select-option>
          </a-select>
        </div>
        <a-divider></a-divider>
        <survey-question-input :canChange="moderator === $page.props.user.id" :room_id="roomId"
                               :surveyQuestion="surveyQuestion"></survey-question-input>
        <a-divider></a-divider>
        <max-vote-input :canChange="moderator === $page.props.user.id" :room_id="roomId"
                        :maxVote="maxVote"></max-vote-input>
        <a-divider></a-divider>
        <div class="flex justify-between py-2 w-full font-black text-black text-lg">
          <label>Enable Retro Wizard: </label>
          <a-switch :disabled="moderator !== $page.props.user.id" @change="permissionUpdated"
                    v-model:checked="permissions.is_wizard_enabled"/>
        </div>
        <small>Tips: if the wizard is enabled, you don't have to update the following toggles.</small>
        <a-divider></a-divider>
        <div class="flex justify-between py-2 w-full font-black text-black text-lg">
          <label>Enable Survey: </label>
          <a-switch :disabled="moderator !== $page.props.user.id" @change="permissionUpdated"
                    v-model:checked="permissions.show_survey"/>
        </div>
        <a-divider></a-divider>
        <div class="flex justify-between py-2 w-full font-black text-black text-lg">
          <label>Can create actions: </label>
          <a-switch :disabled="moderator !== $page.props.user.id" @change="permissionUpdated"
                    v-model:checked="permissions.can_create_actions"/>
        </div>
        <a-divider></a-divider>
        <div class="flex justify-between py-2 w-full font-black text-black text-lg">
          <label> Can move cards: </label>
          <a-switch :disabled="moderator !== $page.props.user.id" @change="permissionUpdated"
                    v-model:checked="permissions.can_move_cards"/>
        </div>
        <a-divider></a-divider>
        <div class="flex justify-between py-2 w-full font-black text-black text-lg">
          <label> Can merge cards: </label>
          <a-switch :disabled="moderator !== $page.props.user.id" @change="permissionUpdated"
                    v-model:checked="permissions.can_merge_cards"/>
        </div>
        <a-divider></a-divider>
        <div class="flex justify-between py-2 w-full font-black text-black text-lg">
          <label> Can vote cards: </label>
          <a-switch :disabled="moderator !== $page.props.user.id" @change="permissionUpdated"
                    v-model:checked="permissions.can_vote_cards"/>
        </div>
        <a-divider></a-divider>
        <div class="flex justify-between py-2 w-full font-black text-black text-lg">
          <label> Can view all votes: </label>
          <a-switch :disabled="moderator !== $page.props.user.id" @change="permissionUpdated"
                    v-model:checked="permissions.can_view_votes"/>
        </div>
        <a-divider></a-divider>
        <div class="flex justify-between py-2 w-full font-black text-black text-lg">
          <label> Can view all cards: </label>
          <a-switch :disabled="moderator !== $page.props.user.id" @change="permissionUpdated"
                    v-model:checked="permissions.can_view_other_cards"/>
        </div>
        <a-divider></a-divider>
        <div class="flex justify-between py-2 w-full font-black text-black text-lg">
          <label> Sort by votes: </label>
          <a-switch :disabled="moderator !== $page.props.user.id" @change="permissionUpdated"
                    v-model:checked="permissions.sort_by_votes"/>
        </div>
      </div>
    </a-drawer>
    <!--    first step retro hasn't be started yet-->
    <input
        type="hidden"
        :id="'board' + roomKey"
        :value="getLink(roomKey)"
    />


    <Lobby :room="lobbyRoom" :show-lobby="!room.is_finished">
      <template #logo>
        <img src="/images/retro.svg" class="h-12 w-12"/>
      </template>

      <template #players>
        <div class="relative" v-for="player in players">
          <div class="px-2">
            <div>
              <label class="text-xl font-bold"
              > {{ player.name }}</label>
            </div>
            <label v-html="player.avatar" class="text-2xl block"></label>
          </div>
        </div>
      </template>

      <template #custom>

        <div class="flex flex-col">
          <div class="flex justify-center">
            <button
                @click="showDrawer"
                class="
                  focus:outline-none
                  text-base
                   max-h-10
                  ml-2
                  bg-gray
                  hover:bg-blue-100
                  text-blue-500
                  border-2
                  py-1
                  px-2
                  border-blue-500
                  font-bold
                  rounded
                "
            >
              <CogIcon class="w-5 h-5 flex-shrink-0 text-black"></CogIcon>
            </button>

            <button
                @click="info(roomKey)"
                class="
                  focus:outline-none
                  text-base
                   max-h-10
                  bg-gray
                  ml-2
                  hover:bg-blue-100
                  text-blue-500
                  border-2
                  py-1
                  px-2
                  border-blue-500
                  font-bold
                  rounded
                "
            >
              <LinkIcon class="w-5 h-5 flex-shrink-0 text-black"></LinkIcon>
            </button>

          </div>


          <div class=" flex justify-center">

            <div class="w-40 text-lg font-bold pt-2">
              <label>Host: </label>
              <a-select
                  v-model:value="moderator"
                  ref="select"
                  class="block shadow w-full"
                  @change="changeModerator($event)"
              >
                <a-select-option v-for="player in players" :value="player.id"
                >{{ player.name }}
                </a-select-option>
                <a-select-option value="no">No Host</a-select-option>
              </a-select>
            </div>

          </div>
        </div>
      </template>
      <template #room>
        <div
            v-if="!gameLoading && moderator ==='no'"
            class="text-center font-bold bg-yellow-100 border-yellow-500 text-orange-700 py-4 mb-10"
            role="alert"
        >
          <p>Your room is missing a host, please <a class="text-blue-400 cursor-pointer" @click="showDrawer">assign</a>
            someone to it.</p>
        </div>
        <div class="h-full">


          <jet-confirmation-modal :show="confirmBox" @close="cancelConfirmAction()">
            <template #title>
              Confirmation Dialog
            </template>

            <template #content>
              {{ confirmContent }}
            </template>

            <template #footer>
              <jet-secondary-button @click="cancelConfirmAction()">
                Cancel
              </jet-secondary-button>

              <jet-danger-button class="ml-2" @click="confirmAction()">
                Confirm
              </jet-danger-button>
            </template>
          </jet-confirmation-modal>


          <div>
            <a-spin :spinning="updatingGameState" style="z-index: 9999;" size="large" tip="🔥 Ready...Go!">

              <div class=" grid gap-4 grid-cols-3">

                <div class="ml-8">
                  <div class="inline-block ml-10">
                    <div class="text-2xl font-bold flex justify-center inline-block">
                      {{ room.room_name }}

                      <button
                          @click="showDrawer"
                          class="
                  focus:outline-none
                  text-base
                   max-h-10
                  ml-2
                  bg-gray
                  hover:bg-blue-100
                  text-blue-500
                  border-2
                  py-1
                  px-2
                  border-blue-500
                  font-bold
                  rounded
                "
                      >
                        <CogIcon class="w-5 h-5 flex-shrink-0 text-black"></CogIcon>
                      </button>

                      <button
                          @click="info(roomKey)"
                          class="
                  focus:outline-none
                  text-base
                   max-h-10
                  bg-gray
                  ml-2
                  hover:bg-blue-100
                  text-blue-500
                  border-2
                  py-1
                  px-2
                  border-blue-500
                  font-bold
                  rounded
                "
                      >
                        <LinkIcon class="w-5 h-5 flex-shrink-0 text-black"></LinkIcon>
                      </button>

                      <button
                          v-if="permissions.show_survey"
                          @click="openSurvey()"
                          :class="isSurveySubmitted ?'': 'animate-bounce'"
                          class="

                  focus:outline-none
                  text-base
                   max-h-10
                  bg-gray
                  ml-2
                  hover:bg-yellow-100
                  border-2
                  py-1
                  px-2
                  border-yellow-500
                  font-bold
                  rounded
                "
                      >
                        <StarIcon :class="isSurveySubmitted ?'': 'animate-bounce'"
                                  class="w-5 h-5 flex-shrink-0 text-yellow-500"></StarIcon>
                      </button>

                      <button
                          v-else
                          @click="openSurvey()"
                          class="

                  focus:outline-none
                  text-base
                   max-h-10
                  bg-gray
                  ml-2
                  hover:bg-yellow-100
                  border-2
                  py-1
                  px-2
                  border-yellow-500
                  font-bold
                  rounded
                "
                      >
                        <StarIcon class="w-5 h-5 flex-shrink-0 text-yellow-500"></StarIcon>
                      </button>
                    </div>
                  </div>

                </div>
                <div>
                  <div class="flex space-x-4 items-center justify-center overflow-x-auto">
                    <div class="inline-block relative" v-for="player in players">
                      <div>


                        <LightBulbIcon v-if="moderator === player.id" class="text-blue-500 h-5 w-5 "></LightBulbIcon>
                        <CheckCircleIcon v-else-if="readyState[player.id] === true"
                                         class="text-green-500 h-5 w-5 "></CheckCircleIcon>
                        <XCircleIcon v-else class="text-red-500 h-5 w-5 "></XCircleIcon>


                        <div>
                          <label class="text-lg font-bold">{{ player.name }}</label>
                        </div>
                        <label v-html="player.avatar" class="text-lg block"></label>
                      </div>
                    </div>
                  </div>

                </div>
                <div class="py-2">
                  <div class="flex items-center justify-center">
                    <div v-if="permissions.is_wizard_enabled" class="inline-block relative">
                      <div v-if="moderator === $page.props.user.id">
                        <div>
                          <button
                              v-if="room.current_step === retroFlowConfig.length"
                              @click="finishRetro()"
                              class="
              text-3xl
                  focus:outline-none
                  text-base
                  mr-2

                  bg-green-400
                  hover:bg-green-200
                  text-black
                  py-3
                  px-3
                  font-bold
                  rounded-full
                  shadow-md
                "
                          >
                            Complete
                          </button>

                          <button
                              v-if="room.current_step > 1"
                              @click="goNext(Number.parseInt(room.current_step)-1)"
                              class="text-3xl focus:outline-none text-base
                  mr-2

                  bg-gray-300
                  hover:bg-gray-200
                  text-black
                  py-3
                  px-3
                  font-bold
                  rounded-full
                  shadow-md
                "
                          >
                            Prev
                          </button>
                          <button
                              v-if="room.current_step < retroFlowConfig.length"
                              @click="goNext(Number.parseInt(room.current_step)+1)"
                              class="
              text-3xl
                  focus:outline-none
                  text-base
                  mr-2

                  bg-blue-300
                  hover:bg-blue-200
                  text-black
                  py-3
                  px-3
                  font-bold
                  rounded-full
                  shadow-md
                "
                          >
                            Next
                          </button>
                          <div class=" inline-block font-bold">
                            ({{ readyUsers }} /{{ players.length }})
                          </div>

                        </div>


                      </div>
                    </div>
                    <div v-else-if="!permissions.is_wizard_enabled" class="inline-block relative">
                      <button
                          @click="finishRetro()"
                          class="
              text-3xl
                  focus:outline-none
                  text-base
                  mr-2

                  bg-green-400
                  hover:bg-green-200
                  text-black
                  py-3
                  px-3
                  font-bold
                  rounded-full
                  shadow-md
                "
                      >
                        Finish
                      </button>
                    </div>

                    <div v-if="moderator !== $page.props.user.id">

                      <div @click="ready(!isReady)" class="

             cursor-pointer text-3xl
                  focus:outline-none
                  text-base
                  mr-2
                  bg-gray
                  bg-green-400
                  hover:bg-green-200
                  text-black
                  py-3
                  px-3
                  font-bold
                  rounded-lg
                  shadow-md

                ">
                        <input type="checkbox"
                               v-model="isReady"
                               class="inline-block focus:ring-yellow-500 bg-blue-50 rounded-full h-8 w-8 text-blue-400 border-green-300"/>
                        <div class="ml-2 inline-block">
                          I'm Ready 😎
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <div v-if="room.is_finished" class="flex justify-center">
                <button
                    @click="goToSummary()"
                    class="
              text-3xl
                  focus:outline-none
                  text-base
                  mr-2

                  bg-yellow-100
                  hover:bg-yellow-200
                  text-black
                  py-3
                  px-3
                  font-bold
                  rounded-full
                  shadow-md
                "
                >
                  Review Summary
                </button>
              </div>
              <div class="mt-5">

                <template v-if="permissions.is_wizard_enabled">

                  <template v-if="retroFlowConfig.length ===0">

                    <div class="mx-4 w-full">
                      <div class="bg-orange-100 border-l-4 border-orange-500 text-orange-700 p-4" role="alert">
                        <p class="font-bold">Be Warned</p>
                        <p> Your board do not have a retro flow configured, please generate a new board.</p>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <retro-flow-wizard
                        :current_step="room.current_step"
                        :flow="retroFlowConfig">
                    </retro-flow-wizard>
                  </template>

                </template>


                <dialog-modal
                    :hideClose="true"
                    :show.sync="isSurveyOpened"
                >

                  <template #content>


                    <div class="w-full">
                      <div class="px-5 pt-7 pb-2">
                        <div class="flex flex-col justify-center">
                          <div class="mb-10 flex justify-center">
                            <label class="font-bold text-2xl">{{ surveyQuestion }} </label>
                          </div>
                          <div class="mb-10 flex justify-center">
                            <a-rate v-model:value="surveyRate" style="font-size: 40px"/>
                          </div>

                        </div>
                      </div>
                    </div>

                    <a-spin :spinning="submittingFeedback">
                      <button
                          @click.prevent="submitSurvey"
                          type="button"
                          class="
                    rounded-full
                    transition
                    duration-200
                    bg-yellow-400
                    hover:bg-yellow-300
                    focus:outline-none
                    text-black
                    w-full
                    py-2.5
                    rounded-lg
                    text-lg
                    font-semibold
                    text-center
                    inline-block
                  "
                      >
                        <span class="inline-block mr-2">Submit</span>
                      </button>
                    </a-spin>
                  </template>

                  <template #footer>
                    <button
                        @click="isSurveyOpened = false; isLaterClicked = true;"
                        type="button"
                        class="
                    rounded-full
                    transition
                    duration-200
                    bg-gray-100
                    hover:bg-gray-300
                    focus:outline-none
                    text-black
                    w-full
                    py-2.5
                    rounded-lg
                    text-lg
                    font-semibold
                    text-center
                    inline-block
                  "
                    >
                      <span class="inline-block mr-2">Maybe later</span>
                    </button>
                    <!--                <secondary-button @click="isRegisteredClicked = false">Close</secondary-button>-->
                  </template>
                </dialog-modal>
                <draggable
                    :list="lists"
                    item-key="id"
                    :disabled="true"
                    group="topics"
                    class=" flex  items-start overflow-x-scroll gap-8 p-8 p-4"
                    ghost-class="ghost"
                >
                  <template #item="{ element : item ,index : listIndex }">
                    <div
                        class=" bg-gray-200 dark:bg-gray-700 rounded-lg h-full w-96 flex-shrink-0  flex-col flex-grow shadow-xl">
                      <div class=" flex flex-col h-60" style="min-width: 212px; min-height: calc(100vh)">
                        <div @mouseover="canDragNow(false)" @mouseout="canDragNow(true)"
                             :class="`bg-${item.color}-400 bg-opacity-90`"
                             class="rounded-t-lg p-4 flex justify-center">

                          <span class="text-lg text-black font-bold">{{ item.header }}</span>
                        </div>

                        <input-card :room-key="roomKey" :color="item.color"
                                    :topic="item.id"/>

                        <div class="overflow-x-hidden vertical flex-grow overflow-y-auto">

                          <draggable
                              :fallback-tolerance="1"
                              :force-fallback="true"
                              :scroll-sensitivity="200"
                              :list="item.cards"
                              item-key="id"
                              tag="transition-group"
                              group="cards"
                              :component-data="{
          tag: 'ul',
          class: [ isAddingNewItem &&  movingListIndex != listIndex ? 'h-full opacity-20 bg-gray-200 mx-4  py-50 overflow-hidden rounded-lg border-dashed border-8 border-gray-400' : 'h-full',listIndex == futureListIndex? `border-${item.color}-400` :''],
          type: 'transition-group',
          name: 'flip-list',
        }"
                              class="list-group"
                              ghost-class="ghost"
                              :move="handleMove"
                              @start="handleDragStart"
                              @end="handleDragEnd"
                              :disabled="isEditing ? true:  (!(permissions.can_merge_cards || permissions.can_move_cards))"
                              :data-list-index="listIndex"
                          >
                            <template #item="{ element ,index }">

                              <li :data-list-index="listIndex"
                                  @mouseover="hoveredCard(element.id)"
                                  :class="canManageCards ? 'cursor-grab':''"
                                  class="w-full rounded-md  block  py-2 ">


                                <a-spin
                                    v-if="permissions.can_view_other_cards|| element.user_id === $page.props.user.id"
                                    :spinning="selectedCard === element.id">

                                  <div
                                      :class="permissions.can_merge_cards ? `cursor-move bg-${item.color}-100 border-${item.color}-400` : `bg-${item.color}-100 border-${item.color}-400`"
                                      data-type="merge-area"
                                      :data-merge-index="index"
                                      class="merge-area border-solid border-2 mx-4 rounded-lg shadow-md hover:border-2  ">
                                    <div style="padding: 5px 20px 5px 9px"
                                         data-type="merge-area"
                                         class="merge-area"
                                         :data-merge-index="index"
                                         :class=" ( listIndex == futureListIndex && index === futureIndex && dragType==='merge-area') ? `border-dashed border-4 bg-${item.color}-200 border-${item.color}-400`:'' ">


                                      <div v-if="isEditing && editedCard === element.id" data-type="merge-area"
                                           :data-merge-index="index">
                                        <edit-card @cancelEdited="cancelEditCard()" @cardEdited="cardEdited()"
                                                   :text="element.text"
                                                   :room-id="roomId" :id="element.id"/>
                                      </div>
                                      <div v-else data-type="merge-area" :data-merge-index="index">
                            <span class="break-words whitespace-pre-line" data-type="merge-area"
                                  :data-merge-index="index">{{ element.text }}</span>
                                      </div>


                                      <div data-type="merge-area" :data-merge-index="index"
                                           class="merge-area mt-1 flex justify-end text-sm block text-gray-600">


                                        <button type="button" class="focus:outline-none  mr-4"
                                                @click="editCard(element.id)"
                                                v-if="hoverCard === element.id &&  editedCard !== element.id">
                                          <PencilIcon class="flex-shrink-0 h-4 w-4 hover:text-black"
                                                      aria-hidden="true"/>
                                        </button>
                                        <button type="button" class="focus:outline-none  mr-4"
                                                @click="deleteCard(element.id)"
                                                v-if="hoverCard === element.id">
                                          <TrashIcon class="flex-shrink-0 h-4 w-4  hover:text-black"
                                                     aria-hidden="true"/>
                                        </button>
                                        <button type="button" class="focus:outline-none  mr-2 "
                                                @click="unmerge(element.id)"
                                                v-if=" element.is_merged && permissions.can_merge_cards">
                                          <ScissorsIcon class="flex-shrink-0 h-4 w-4  hover:text-black"
                                                        aria-hidden="true"/>
                                        </button>


                                        <template v-if=" permissions.can_view_votes">
                                          <button
                                              v-if="!item.myvotes[element.id]"
                                              type="button"
                                              class="focus:outline-none"
                                          >
                                            <ThumbUpIcon class=" mr-1 flex-shrink-0 h-4 w-4  hover:text-black"
                                                         aria-hidden="true"/>
                                          </button>
                                          <button v-else
                                                  class="focus:outline-none">
                                            <ThumbUpSolidIcon class="mr-1 flex-shrink-0 h-4 w-4  hover:text-black"
                                                              aria-hidden="true"/>
                                          </button>
                                          <span class="mr-1 flex-shrink-0 h-4 w-2 ">{{
                                              element.votes
                                            }}</span>
                                        </template>


                                        <template v-if=" permissions.can_vote_cards">
                                          <button class="focus:outline-none" @click="vote(element.id, true)">
                                            <PlusSmIcon class="mr-1 flex-shrink-0 h-4 w-4  hover:text-black"
                                                        aria-hidden="true"/>
                                          </button>
                                          <span v-if="permissions.can_vote_cards || permissions.can_view_votes"
                                                class="mr-1 flex-shrink-0 h-4 w-2 ">{{
                                              element.votes
                                            }}</span>
                                          <button :disabled="element.votes === 0" class="focus:outline-none"
                                                  @click="vote(element.id, false)">
                                            <MinusSmIcon class="mr-1 flex-shrink-0 h-4 w-4  hover:text-black"
                                                         aria-hidden="true"/>
                                          </button>
                                        </template>


                                        <button type="button" class="focus:outline-none"
                                                @click="addAction(element.id)"
                                                v-if="permissions.can_create_actions">
                                          <ChatIcon class="flex-shrink-0 h-4 w-4  hover:text-black"
                                                    aria-hidden="true"/>
                                        </button>
                                        <span v-if="permissions.can_create_actions"
                                              class="ml-1 flex-shrink-0 h-4 w-2 ">{{
                                            actionGroup[element.id]?.length
                                          }}</span>
                                        <span class="h-4"></span>

                                      </div>

                                      <div data-type="merge-area"
                                           :data-merge-index="index" class="mt-2">
                                        <div v-if="isEditing && selectCardForAction === element.id"
                                             class=" border-transparent  mx-2 mb-2 py-2 px-2 rounded-lg  hover:border-2 hover:cursor-none ">
                                          <comment-card @cancelAction="cancelAddAction()" @actionAdded="actionAdded()"
                                                        :room-id="roomId" :card-id="element.id"/>
                                        </div>

                                        <div
                                            v-for="action in actionGroup[element.id]"
                                            :class="`bg-${item.color}-50 border-${item.color}-400`"
                                            class="border-solid  border-2 mx-4 mb-2 py-2 px-2 rounded-lg shadow-md hover:border-2 hover:cursor-none "
                                            data-type="merge-area"
                                            :data-merge-index="index">


                                          <div v-if="isEditing && selectedAction === action.id" data-type="merge-area"
                                               :data-merge-index="index">
                                            <edit-action @cancelEdited="cancelEditAction()" @cardEdited="actionEdited()"
                                                         :text="action.action"
                                                         :room-id="roomId" :id="action.id"/>
                                          </div>
                                          <div v-else data-type="merge-area" :data-merge-index="index">
                            <span class="break-words whitespace-pre-line" data-type="merge-area"
                                  :data-merge-index="index">{{ action.action }}</span>
                                          </div>


                                          <div class="mt-1 mb-2 flex justify-end text-sm block text-gray-600">

                                            <button type="button" class="focus:outline-none  mr-4"
                                                    @click="editAction(action.id)">
                                              <PencilIcon class="flex-shrink-0 h-4 w-4 hover:text-black"
                                                          aria-hidden="true"/>
                                            </button>
                                            <button type="button" class="focus:outline-none  mr-4"
                                                    @click="deleteAction(action.id)">
                                              <TrashIcon class="flex-shrink-0 h-4 w-4  hover:text-black"
                                                         aria-hidden="true"/>
                                            </button>
                                          </div>
                                        </div>

                                      </div>
                                    </div>


                                  </div>

                                </a-spin>


                                <div v-else
                                     data-type="drop-area"
                                     :data-drop-index="index"
                                     :class="`mt-2 border-solid border-2 p-4 border-${item.color}-400 shadow rounded-md mx-4`">
                                  <div class="animate-pulse flex space-x-4">
                                    <div :class="`rounded-full bg-${item.color}-400 h-12 w-12`"></div>
                                    <div class="flex-1 space-y-4 py-1">
                                      <div :class="`h-4 bg-${item.color}-400 rounded w-3/4`"></div>
                                      <div class="space-y-2">
                                        <div :class="`h-4 bg-${item.color}-400 rounded`"></div>
                                        <div :class="`h-4 bg-${item.color}-400 rounded w-5/6`"></div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                              </li>

                            </template>
                          </draggable>
                        </div>
                      </div>
                    </div>
                  </template>
                </draggable>
              </div>


            </a-spin>
          </div>


        </div>
      </template>
    </Lobby>

  </app-layout>

</template>

<script>
import {notification} from 'ant-design-vue';
import draggable from "vuedraggable";
import AppLayout from "@/Layouts/AppLayout";
import {onMounted, ref, computed} from "vue";
import {Inertia} from "@inertiajs/inertia";

import {
  ScissorsIcon,
  TrashIcon,
  CheckIcon,
  PlusIcon,
  XIcon,
  ThumbUpIcon,
  ChatIcon,
  PencilIcon,
  LinkIcon,
  HomeIcon,
  CogIcon,
  CheckCircleIcon,
  ArrowLeftIcon,
  XCircleIcon,
  CursorClickIcon,
  LightBulbIcon,
} from "@heroicons/vue/outline";
import {
  ThumbUpIcon as ThumbUpSolidIcon,
  StarIcon,
  PlusSmIcon,
  MinusSmIcon
} from "@heroicons/vue/solid";
import JetConfirmationModal from '@/Jetstream/ConfirmationModal'
import JetDangerButton from '@/Jetstream/DangerButton'
import JetSecondaryButton from '@/Jetstream/SecondaryButton'
import JetDialogModal from "@/Jetstream/DialogModal";
import InputCard from "@/Pages/Retrospective/Components/InputCard";
import {message} from "ant-design-vue";
import EditCard from "@/Pages/Retrospective/Components/EditCard";
import DialogModal from "@/Jetstream/DialogModal";
import CommentCard from "@/Pages/Retrospective/Components/CommentCard";
import EditAction from "@/Pages/Retrospective/Components/EditAction";
import RetroFlowWizard from "@/Pages/Retrospective/Components/RetroFlowWizard";
import SurveyQuestionInput from "@/Pages/Retrospective/Components/SurveyQuestionInput";
import Feedback from "@/Components/Feedback";
import WaitingList from "../Lobby/Components/WaitingList";
import {getCurrentInstance} from "vue";
import Lobby from "@/Pages/Lobby/Lobby";
import emitter from "tiny-emitter/instance";
import MaxVoteInput from "@/Pages/Retrospective/Components/MaxVoteInput";

export default {
  props: {
    lobbyRoom: {
      type: Object,
      required: false,
    },
    roomKey: {
      type: String,
      required: true,
    },
    roomId: {
      type: Number,
    },
  },
  watch: {
    timeOutDragging() {
      this.isValidDragging = false;
    }
  },
  components: {
    PlusSmIcon,
    MaxVoteInput,
    emitter,
    Lobby,
    WaitingList,
    Feedback,
    SurveyQuestionInput,
    RetroFlowWizard,
    EditAction,
    CommentCard,
    DialogModal,
    LightBulbIcon,
    EditCard,
    HomeIcon,
    TrashIcon,
    InputCard,
    StarIcon,
    PencilIcon,
    XCircleIcon,
    CheckIcon,
    ArrowLeftIcon,
    XIcon,
    PlusIcon,
    ThumbUpIcon,
    ThumbUpSolidIcon,
    LinkIcon,
    ChatIcon,
    MinusSmIcon,
    AppLayout,
    CursorClickIcon,
    CogIcon,
    draggable,
    JetConfirmationModal,
    JetDialogModal,
    JetDangerButton,
    CheckCircleIcon,
    ScissorsIcon,
    JetSecondaryButton,
    Inertia
  },
  unmounted() {
    Echo.leave("retro-room." + this.roomKey)
    console.log('unmounted')
  },
  mounted() {
    if (this.$page.props.user) {
      this.gameLoading = true;
      console.log('connect')
      Echo.join("retro-room." + this.roomKey)
          .listen("CardEvent", (e) => {
            console.log('card event')
            console.log(this.isMoving)
            console.log('------')
            let ifLoaded = false;
            if (e.userId !== this.$page.props.user.id && this.isMoving === false) {
              ifLoaded = true;
              this.fetchCards(false);
            }

            if (this.isEditing === false && this.isMoving === false && ifLoaded === false) {
              this.fetchCards(false);
            }
          })
          .listen('RetroGameFinished', async (e) => {
            this.goToSummary(1);
          })
          .listen('LobbyEvent', async (e) => {
            emitter.emit('VueLobbyEvent', e);
            if (e.approvedUserId === this.$page.props.user.id) {
              location.reload();
            }
          })
          .here((users) => {
            console.log("Pusher users");
            //console.log(users);
            this.players = users.map((user, index) => {
              // get current player
              return this.userTransFormer(user);
            });
          })
          .joining((user) => {
            console.log("new user joined");
            console.log(user);
            this.players.push(this.userTransFormer(user));
          })
          .leaving((user) => {
            //console.log("user leaving");
            //console.log(user);
            //console.log("=====");

            //console.log("before leaving");
            //console.log(this.players);
            this.players.splice(
                this.players.findIndex(function (i) {
                  return i.id === user.original.id;
                }),
                1
            );
            //console.log("after leaving");
            //console.log(this.players);
          })
          .error((error) => {
            //console.log("erro");
            //console.error(error);
          });
    }
  },
  data() {
    return {
      isMoving: false,
      isValidMove: false,
      isValidDragging: false,
      emptyStyle: {
        'min-height': '20%',
        'border-style': 'dashed',
        'border-color': '#6B7280',
        'border-width': '8px',
        'border-radius': '0.5rem',
        'margin-top': '1rem',
        'margin-left': '1rem',
        'margin-right': '1rem'
      },
      selectedStyle: {
        'min-height': '20%',
        'border-style': 'dashed',
        'border-radius': '0.5rem',
        'border-color': '#3B82F6',
        'border-width': '8px',
        'margin-top': '1rem',
        'margin-left': '1rem',
        'margin-right': '1rem'
      },
      mergeActionModal: false,
      movingIndex: null,
      movingListIndex: null,
      futureListIndex: null,
      futureIndex: null,
      dragType: null,
      enabled: true,
      dragging: true,
    }
  },
  setup(props, context) {
    const visible = ref(false);
    const instance = getCurrentInstance();
    const afterVisibleChange = (bool) => {
      console.log('visible', bool);
    };

    const showDrawer = () => {
      visible.value = true;
    };

    const isSurveyOpened = ref(false);

    const lists = ref([]);
    const selectedCard = ref(null);
    const canDrag = ref(true);
    const hoverCard = ref(null);
    const isEditing = ref(false);
    const editedCard = ref(null);
    const commentCard = ref(null);
    const isSurveySubmitted = ref(false);
    const showReview = ref(false);
    const isReady = ref(true);
    const updatingGameState = ref(false);
    const readyState = ref({});
    const actionGroup = ref({});
    const surveyQuestion = ref('');
    const maxVote = ref('');
    const isLaterClicked = ref(false);
    const permissions = ref({
      is_wizard_enabled: false,
      show_survey: false,
      can_create_actions: false,
      can_move_cards: false,
      can_merge_cards: false,
      can_vote_cards: false,
      can_view_votes: false,
      can_view_other_cards: false,
      sort_by_votes: false,
    });
    const retroFlowConfig = ref([]);
    const moderator = ref('no');
    const room = ref({
      is_finished: false,
      current_step: 0,
      room_name: '',
      created_by: null,
      room_key: '',
      room_id: '',
      max_votes: null,
      voted: null,
      team_owner_name: '',
      team_id: '',
      room_type: '',
      team_owner_id: '',
      is_public: false,
    });

    function canDragNow(value) {
      canDrag.value = value;
    }

    const submittingFeedback = ref(false);
    const players = ref([]);
    const confirmBox = ref(false);

    const gameLoading = ref(true);
    const confirmProps = ref({});
    const confirmContent = ref('Are you sure?');

    const cancelConfirmAction = () => {
      confirmContent.value = 'Are you sure?';
      confirmBox.value = false;
      confirmProps.value.func = () => {
      };
    }
    const confirmAction = () => {
      confirmBox.value = false;
      confirmProps.value.func();
    }


    const readyUsers = computed(() => {
      let ready = 0;
      for (let player of players.value) {
        if (player.id != moderator.value && (readyState.value[player.id] === false || !readyState.value[player.id])) {

        } else {
          ready++;
        }
      }
      return ready;
    });

    function goNext(step) {

      let ifFound = false;
      if (room.value.current_step < step) {
        for (let player of players.value) {
          if (player.id != moderator.value && (readyState.value[player.id] === false || !readyState.value[player.id])) {
            ifFound = true;
            break;
          }
        }
      }

      if (ifFound === true) {
        confirmBox.value = true;
        confirmContent.value = 'Someone is not ready, are you sure?';
        confirmProps.value.func = () => {
          updatingGameState.value = true;
          axios
              .post(route("retrospective.room.goNext", {
                room_id: props.roomId,
                next_step: step
              }))
              .then((response) => {
                room.value.current_step = step
                updatingGameState.value = false;
              })
              .catch((error) => {
                console.log(error);
                updatingGameState.value = false;
              });
        }
      } else {
        updatingGameState.value = true;
        axios
            .post(route("retrospective.room.goNext", {
              room_id: props.roomId,
              next_step: step
            }))
            .then((response) => {
              room.value.current_step = step
              updatingGameState.value = false;
              notification['warning']({
                message: retroFlowConfig.value[room.value.current_step - 1]['name'],
                description:
                    retroFlowConfig.value[room.value.current_step - 1]['desc'],
              });
            })
            .catch((error) => {
              console.log(error);
              updatingGameState.value = false;
            });
      }

    }

    function permissionUpdated() {
      axios
          .post(route("retrospective.room.permissionUpdated", {
            room_key: props.roomKey,
            permissions: permissions.value
          }))
          .then((response) => {
            message.success('Permission updated');
          })
          .catch((error) => {
            console.log(error);
          });
    }

    const isWarningShowedUp = ref(false);

    async function fetchCards(withSpinning = true) {
      if (isEditing.value === true) {
        if (isWarningShowedUp.value === false) {
          isWarningShowedUp.value = true;
          notification['warning']({
            onClose: () => {
              isWarningShowedUp.value = false;
            },
            duration: 0,
            placement: 'bottomLeft',
            message: 'Cards were updated by others',
            description:
                'Save or cancel your edit box to reload new data.',
          });
        }
        return;
      }

      if (withSpinning) {
        updatingGameState.value = true;
      }
      await axios
          .get(route("retrospective.room.get.room", {
            room_id: props.roomId,
          }))
          .then((response) => {
            const responseData = response.data.data;
            retroFlowConfig.value = responseData.retro_flow_config;

            // // for normal user
            // if (permissions.value.is_wizard_enabled && room.value.current_step !== responseData.room.current_step) {
            //   notification['warning']({
            //     message: retroFlowConfig.value[responseData.room.current_step - 1]['name'],
            //     description:
            //         retroFlowConfig.value[responseData.room.current_step - 1]['desc'],
            //   });
            // }

            permissions.value = responseData.permissions;
            isSurveySubmitted.value = responseData.is_survey_submitted;
            if (permissions.value.show_survey
                && isSurveySubmitted.value === false
                && isLaterClicked.value === false
            ) {
              isSurveyOpened.value = true;
            }

            surveyQuestion.value = responseData.survey_question;
            maxVote.value = responseData.room.max_votes;
            isReady.value = responseData.is_ready;
            actionGroup.value = responseData.action_group;
            moderator.value = responseData.moderator ?? 'no';
            lists.value = responseData.result;
            room.value = responseData.room;
            readyState.value = responseData.ready;
            updatingGameState.value = false;
          })
          .catch((error) => {
            updatingGameState.value = false;
            console.log(error);
          });

      gameLoading.value = false;
    }

    function ready(value) {
      console.log(`ready value ${value}`)
      updatingGameState.value = true;
      axios
          .post(route("retrospective.room.ready", {
            room_id: props.roomId,
            is_ready: value
          }))
          .then((response) => {
            updatingGameState.value = false;
            isReady.value = value;
          })
          .catch((error) => {
            updatingGameState.value = false;
            console.log(error);
          });
    }


    async function finishRetro() {
      updatingGameState.value = true;
      await axios
          .post(route("retrospective.room.finishRetro", {
            room_id: props.roomId,
          }))
          .then((response) => {
            updatingGameState.value = false;
          })
          .catch((error) => {
            updatingGameState.value = false;
            console.log(error);
          });
    }

    function goToSummary(showReview = 0) {
      Inertia.visit(route('retrospective.room.summary', {room_key: props.roomKey, showReview: showReview}))
    }

    function hoveredCard(cardId, value) {
      if (value === false) {
        hoverCard.value = null;
      } else {
        hoverCard.value = cardId;
      }
    }

    function vote(cardId, increaseVote) {
      if (!permissions.value.can_vote_cards) {
        message.warning('Voting cards is not allowed in your current step.');
        return;
      }
      axios
          .post(route("retrospective.card.voteCard", {
            room_id: props.roomId,
            card_id: cardId,
            increase: increaseVote
          }))
          .then((response) => {
            if (response.data.success) {
              selectedCard.value = null;
              if (!permissions.can_view_votes) {
                fetchCards(false);
              }
              message.info('Vote:' + response.data.voted + '/' + room.value.max_votes);

            } else {
              selectedCard.value = null;
              message.error(response.data.message);
            }
          })
          .catch((error) => {
            selectedCard.value = null;
            console.log(error);
            message.error("Oops, something went wrong.");
          });
    }

    function unmerge(cardId) {

      confirmBox.value = true;
      confirmContent.value = 'Are you sure you want to unmerge it?';
      confirmProps.value.func = () => {
        selectedCard.value = cardId;
        axios
            .post(route("retrospective.card.unmerge", {
              room_id: props.roomId,
              id: cardId,
            }))
            .then((response) => {
              if (response.data.success) {
                selectedCard.value = null;
                message.success("Your card is unmerged");
              } else {
                selectedCard.value = null;
                console.log(error);
                message.error("Oops, something went wrong.");
              }
            })
            .catch((error) => {
              selectedCard.value = null;
              console.log(error);
              message.error("Oops, something went wrong.");
            });

      }
    }


    function deleteAction(cardId) {
      confirmBox.value = true;
      confirmContent.value = 'Are you sure you want to delete this action?';
      confirmProps.value.func = () => {
        axios
            .delete(route("retrospective.card.deleteAction", {
              room_id: props.roomId,
              action_id: cardId,
            }))
            .then((response) => {
              commentCard.value = null;
              isEditing.value = false;
              message.success("Your action is deleted");
            })
            .catch((error) => {
              commentCard.value = null;
              isEditing.value = false;
              console.log(error);
              message.error("Oops, something went wrong.");
            });
      };

    }

    const surveyRate = ref(2);


    function submitSurvey() {
      submittingFeedback.value = true;
      axios
          .post(route("retrospective.room.survey", {
            room_id: props.roomId,
            rate: surveyRate.value,
          }))
          .then((response) => {
            isSurveySubmitted.value = true;
            submittingFeedback.value = false;
            isSurveyOpened.value = false;
            message.success("Your survey answer is submitted.");
          })
          .catch((error) => {
            selectedCard.value = null;
            submittingFeedback.value = false;
            console.log(error);
            message.error("Oops, something went wrong.");
          });

    }

    function deleteCard(cardId) {
      confirmBox.value = true;
      confirmContent.value = 'Are you sure you want to delete this card?';
      confirmProps.value.func = () => {
        selectedCard.value = cardId;
        axios
            .delete(route("retrospective.card.delete", {
              room_id: props.roomId,
              card_id: cardId,
            }))
            .then((response) => {
              selectedCard.value = null;
              message.success("Your card is deleted");
            })
            .catch((error) => {
              selectedCard.value = null;
              console.log(error);
              message.error("Oops, something went wrong.");
            });
      }
    }


    onMounted(async () => {
      await fetchCards();
    });


    function canManageCards() {
      return permissions.value.can_move_cards || permissions.value.can_merge_cards;
    }


    function openSurvey() {
      isSurveyOpened.value = true;
    }

    function rest() {
      isEditing.value = false;
      selectedAction.value = null;
      selectCardForAction.value = null;
      editedCard.value = null;
    }

    /**
     * 卡片编辑
     */
    function editCard(cardId) {
      isEditing.value = true;
      editedCard.value = cardId;
    }

    function cardEdited() {
      console.log('s1ss');
      rest();
      fetchCards(false);
    }

    function cancelEditCard() {
      rest();
      fetchCards(false);
    }

    /**
     * 增加action
     */
    const selectCardForAction = ref(null);

    /**
     * 卡片编辑
     */
    function addAction(cardId) {
      console.log('add-action')
      isEditing.value = true;
      selectCardForAction.value = cardId;
    }

    function actionAdded() {
      rest();
      fetchCards(false);
    }

    function cancelAddAction() {
      console.log('cancel add action')
      rest();
      fetchCards(false);
    }


    /**
     * 编辑action
     */
    const selectedAction = ref(null);

    /**
     * 卡片编辑
     */
    function editAction(actionId) {
      isEditing.value = true;
      selectedAction.value = actionId;
    }

    function actionEdited() {
      rest();
      fetchCards(false);
    }

    function cancelEditAction() {
      rest();
      fetchCards(false);
    }


    return {
      showReview,
      readyUsers,
      cancelConfirmAction,
      confirmContent,
      confirmProps,
      confirmAction,
      confirmBox,
      players,
      goToSummary,
      isLaterClicked,
      surveyRate,
      maxVote,
      surveyQuestion,
      selectedAction,
      selectCardForAction,
      cancelEditAction,
      actionEdited,
      editAction,
      cancelAddAction,
      actionAdded,
      addAction,
      editCard,
      cardEdited,
      cancelEditCard,
      finishRetro,
      retroFlowConfig,
      openSurvey,
      submittingFeedback,
      submitSurvey,
      isSurveyOpened,
      isSurveySubmitted,
      canManageCards,
      deleteAction,
      commentCard,
      actionGroup,
      permissionUpdated,
      permissions,
      visible,
      afterVisibleChange,
      showDrawer,
      goNext,
      moderator,
      readyState,
      isReady,
      ready,
      room,
      isEditing,
      editedCard,
      canDragNow,
      canDrag,
      selectedCard,
      deleteCard,
      fetchCards,
      unmerge,
      hoveredCard,
      updatingGameState,
      hoverCard,
      lists,
      vote,
      gameLoading
    };
  },
  computed: {
    draggingInfo() {
      return this.dragging ? "under drag" : "";
    },
    isAddingNewItem: function () {
      // `this` points to the vm instance
      return this.futureListIndex !== this.movingListIndex;
    },
  },
  methods: {
    getSelectedStyle(color) {
      return {
        'min-height': '20%',
        'border-style': 'dashed',
        'border-radius': '0.5rem',
        'border-color': 'bg-' + color + '-400',
        'border-width': '8px',
        'margin-top': '1rem',
        'margin-left': '1rem',
        'margin-right': '1rem'
      }
    },
    info(roomKey) {
      let testingCodeToCopy = document.querySelector("#board" + roomKey);
      testingCodeToCopy.setAttribute("type", "text"); // 不是 hidden 才能複製
      testingCodeToCopy.select();

      try {
        document.execCommand("copy");
        message.success("Your link is copied");
      } catch (err) {
        message.error("Oops, unable to copy");
      }

      /* unselect the range */
      testingCodeToCopy.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    },
    getLink(id) {
      return this.$page.props.env !== 'production' ? 'https://staging.agilesuite.io/boards/' + id : 'https://agilesuite.io/boards/' + id;
    },
    changeModerator(value) {
      let app = this;
      app.updatingGameState = true;
      axios
          .post(route("retrospective.changeModerator"), {
            room_id: app.roomId,
            moderator: value === "no" ? null : value,
          })
          .then((response) => {
            app.updatingGameState = false;
            // app.moderator = value;
          })
          .catch((error) => {
            app.updatingGameState = false;
            //console.log(error);
          });
    },
    userTransFormer(pusherUser) {
      return {
        id: pusherUser.original.id,
        name: pusherUser.original.name,
        avatar: pusherUser.original.avatar_url,
        photo: pusherUser.original.photo,
      };
    },
    handleDragEnd(evt) {

      this.isMoving = false;
      if (this.isValidMove === false) {
        this.fetchCards(false);
        return;
      }

      // console.log(targetIndex)
      // console.log(this.movingIndex )
      // console.log(targetListIndex)
      // console.log(this.futureListIndex )
      // if(this.movingIndex == targetIndex && this.futureListIndex == targetListIndex){
      //   return;
      // }
      // console.log(this.dragType);
      // console.log(this.futureIndex);
      // console.log(this.movingIndex);

      if (
          (this.movingIndex >= 0 && this.futureIndex >= 0 && this.futureIndex !== this.movingIndex) ||
          (this.movingListIndex !== this.futureListIndex)
      ) {
        const fromList = this.lists[this.movingListIndex].cards;
        const toList = this.lists[this.futureListIndex].cards;

        switch (this.dragType) {
          case 'drop-area':

            if (!this.permissions.can_move_cards) {
              this.resetItems();
              this.fetchCards(false);
              alert('Move card is disabled, please change your setting.')
              return;
            }

            // if (!confirm('Are you sure you want to move this card?')) {
            //   this.resetItems();
            //   return;
            // }
            if (fromList[this.movingIndex]) {


              this.movingItem = fromList[this.movingIndex];
              this.futureItem = toList[this.futureIndex] ?? null;
              this.selectedCard = this.movingItem.id;

              axios
                  .post(route("retrospective.card.move", {
                    room_id: this.roomId,
                    is_first: !this.futureItem ? 1 : 0,
                    moving_card_id: this.movingItem.id,
                    future_card_id: this.futureItem?.id,
                    future_list_id: this.lists[this.futureListIndex].id
                  }))
                  .then((response) => {
                    this.selectedCard = null;
                    if (response.data.success) {
                      message.success("Your card is moved.");
                    } else {
                      this.fetchCards(false);
                      message.warning(response.data.message);
                    }
                    console.log(response)
                  })
                  .catch((error) => {
                    this.selectedCard = null;
                    message.error("Oops, something went wrong.");
                  });
            }
            // if (this.movingListIndex !== this.futureListIndex) {
            //   this.movingItem = fromList[this.movingIndex];
            //   this.futureItem = toList[this.futureIndex];
            //   toItems.splice(this.futureIndex, 0, this.movingItem);
            //   fromItems.splice(this.movingIndex, 1);
            //   this.lists[this.movingListIndex].cards = fromItems;
            //   this.lists[this.futureListIndex].cards = toItems;
            // } else {
            //   this.futureItem = fromList[this.futureIndex];
            //   this.movingItem = fromList[this.movingIndex];
            //   fromItems[this.futureIndex] = this.movingItem;
            //   fromItems[this.movingIndex] = this.futureItem;
            //   this.lists[this.movingListIndex].cards = fromItems;
            // }

            break;
          case 'merge-area':

            if (!this.permissions.can_merge_cards) {
              this.resetItems();
              this.fetchCards(false);
              alert('Merge card is disabled, please change your setting.')
              return;
            }
            if (confirm('are you sure?')) {

              if (fromList[this.movingIndex] && toList[this.futureIndex]) {
                this.movingItem = fromList[this.movingIndex];
                this.futureItem = toList[this.futureIndex];
                this.selectedCard = this.futureItem.id;
                axios
                    .post(route("retrospective.card.merge", {
                      room_id: this.roomId,
                      from_id: this.movingItem.id,
                      to_id: this.futureItem.id
                    }))
                    .then((response) => {
                      this.selectedCard = null;

                      console.log(response.data);

                      console.log(response.data.message);
                      if (response.data.success) {
                        message.success("Your card is merged");
                      } else {
                        this.fetchCards(false);
                        message.warning(response.data.message);
                      }
                    })
                    .catch((error) => {
                      this.selectedCard = null;
                      message.error("Oops, something went wrong.");
                    });
              }
            }
            break;
          default:
            if (!this.permissions.can_move_cards) {
              this.resetItems();
              this.fetchCards(false);
              alert('Move card is disabled, please change your setting.')
              return;
            }
            // console.log(this.dragType);
            if (this.dragType === null && fromList[this.movingIndex]) {
              this.movingItem = fromList[this.movingIndex];
              axios
                  .post(route("retrospective.card.move", {
                    room_id: this.roomId,
                    moving_card_id: this.movingItem.id,
                    future_list_id: this.lists[this.futureListIndex].id,
                  }))
                  .then((response) => {
                    this.selectedCard = null;
                    if (response.data.success) {
                      message.success("Your card is moved.");
                    } else {
                      this.fetchCards(false);
                      message.warning(response.data.message);
                    }
                    console.log(response)
                  })
                  .catch((error) => {
                    this.selectedCard = null;
                    message.error("Oops, something went wrong.");
                  });
              // this.movingItem = fromList[this.movingIndex];
              // fromItems.splice(this.movingIndex, 1);
              // this.lists[this.movingListIndex].cards = fromItems;
              // this.lists[this.futureListIndex].cards.push({...this.movingItem})
            }
            break;
        }
        this.resetItems();
      }

    },
    resetItems() {
      this.isMoving = false;
      this.movingIndex = null;
      this.futureIndex = null;
      this.isValidMove = false;
      this.movingListIndex = null;
      this.futureListIndex = null;
    },
    handleDragStart() {
      this.movingIndex = null;
      this.futureIndex = null;
      this.isMoving = true;
    },
    handleMove(e) {
      this.isValidMove = true;
      try {
        const {index, futureIndex} = e.draggedContext;


        this.movingListIndex = e.dragged.dataset.listIndex;
        this.futureListIndex = e.to.dataset.listIndex;

        if (this.movingListIndex !== this.futureListIndex) {
          this.dragType = 'drop-area';
          this.futureIndex = 0;
          this.movingIndex = index;
        } else {
          this.dragType = 'merge-area';
          this.futureIndex = futureIndex;
          this.movingIndex = index;
        }

        // console.log('----');
        // // console.log(this.futureListIndex);
        // // console.log(this.movingListIndex);
        // console.log(this.movingIndex);
        // console.log(this.futureIndex);
        // console.log(this.dragType);
        // this.timeOutDragging();
        // console.log('----');

      } catch (erro) {
        return false; // disable sort
      }
      return false; // disable sort
    },
    // remove(e){
    //   console.log(e)
    // },
    // unchoose(e){
    //   console.log(e)
    // },
    // choose(e){
    //   console.log(e)
    // },
    // sort(e){
    //   console.log(e)
    // },
    // update(e){
    //   console.log(e)
    // }
  }
};
</script>
<style scoped>
/*.buttons {*/
/*  margin-top: 35px;*/
/*}*/


/*.ghost {*/
/*  opacity: 0.5;*/
/*  background: #c8ebfb;*/
/*}*/


.button {
  margin-top: 35px;
}

.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.2;
  border-style: dashed;
  --tw-border-opacity: 1;
  border-width: 2px;
  border-color: rgba(167, 139, 250, var(--tw-border-opacity));
  /*background: #c8ebfb;*/
}

.min-empty-height {
  min-height: 100px;
}

.list-group {
  min-height: 20px;
}

.list-group-item {
  cursor: move;
}

.list-group-item i {
  cursor: pointer;
}


.blue-circle {
  animation-delay: 0.1s;
}

.green-circle {
  animation-delay: 0.2s;
}

.red-circle {
  animation-delay: 0.3s;
}


.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}

.hideScroll::-webkit-scrollbar {
  width: 0 !important
}

.hideScroll {
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
}

.hideScroll {
  overflow: -moz-scrollbars-none;
}


.parent {
  transform: rotateX(180deg);
  overflow-x: auto;
}

.child {
  transform: rotateX(180deg);
}
</style>